module.exports = __webpack_public_path__ + "static/img/msg1.46ba4d66.svg";